import React from "react";

export const Image = ({ title, image }) => {
  return (
    <div className="portfolio-item">
      <div className="hover-bg">
        {" "}
        <a href={`/prestation?name=${title}`} title={title} data-lightbox-gallery="gallery1">
          <div className="hover-text">
            <h4>Nos prestations</h4>
          </div>
          <img src={image} className="img-responsive" alt={title} style={{borderRadius: "10px", width: "100%"}}/>{" "}
        </a>{" "}
      </div>
    </div>
  );
};
